import { PropsWithChildren } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import AddressIcon from '@/Components/icons/address.svg?react'
import PackageIcon from '@/Components/icons/package.svg?react'
import ProfileIcon from '@/Components/icons/profile.svg?react'
import { Tabs } from '@/Components/Tabs'
import { RoutePath } from '@/RoutePath'

const tabsItems = [
  { label: 'פרופיל אישי', value: RoutePath.ClientProfile, icon: <ProfileIcon className='size-5' /> },
  { label: 'החבילות שלי', value: RoutePath.ClientPkg, icon: <PackageIcon className='size-5' /> },
  { label: 'הכתובות שלי', value: RoutePath.ClientAddresses, icon: <AddressIcon className='size-5' /> },
]
export default function ClientPage({ children }: PropsWithChildren) {
  const location = useLocation()
  const getActiveTab = () => {
    if (location.pathname.includes(RoutePath.ClientProfile)) return RoutePath.ClientProfile
    if (location.pathname.includes(RoutePath.ClientPkg)) return RoutePath.ClientPkg
    if (location.pathname.includes(RoutePath.ClientAddresses)) return RoutePath.ClientAddresses
    return ''
  }
  const activeTab = getActiveTab()
  const history = useHistory()

  const handleTabChange = (value: string) => {
    history.push(value)
  }
  if (!activeTab) {
    history.push(RoutePath.ClientPkg)
    return null
  }
  return (
    <div dir='rtl' className='bg-background-app'>
      <Tabs
        variant='underline'
        items={tabsItems}
        value={getActiveTab()}
        className='border-border-default border-b bg-white'
        onChange={handleTabChange}
      />
      <div className='h-[calc(100dvh-64px-var(--navbar-height))] overflow-y-auto pb-6'>{children}</div>
    </div>
  )
}
